import styled, {keyframes} from 'styled-components';
import {useMute} from "../contexts/MuteContext";
import {HowToPlayModal} from "./modal";
import React, {useEffect, useState} from "react";
import {TimepassSDK} from "../assets/images/TimepassAPI/TimepassSDK";
import {LeaderboardModal} from "./leaderboardModal";
import {useGame} from "../contexts/GameContext";
import {audioEngine} from "./audioMap";

const IconContainer = styled.div`
    display: flex;
    position: absolute;
    top: 10px;
    right: 10px;
    justify-content: flex-end;
    gap: 8px;
`;

const Icon = styled.img`
    width: 35px;
    height: 35px;
    cursor: pointer;
`;

const bounce = keyframes`
    0%, 20%, 50%, 80%, 100% {
        transform: translateY(0);
    }
    40% {
        transform: translateY(-5px);
    }
    60% {
        transform: translateY(5px);
    }
`;

const Pointer = styled.div`
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    animation: ${bounce} 2s infinite;
    z-index: 10000005;
    pointer-events: none;
    width: 30px;
    height: 40px;
`;

export default function Actions({windowHeight}: { windowHeight: number }) {
    const {checkedNumbers, prizeWinners, prizeWinner} = useGame();
    const {isMuted, toggleMute} = useMute();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLeaderboardModalOpen, setIsLeaderboardModalOpen] = useState(false);
    const [showHowToPointer, setShowHowToPointer] = useState(false);
    const [showLeaderboardPointer, setShowLeaderboardPointer] = useState(false);
    // Trigger hand on "How to Play" once when the first number is called
    useEffect(() => {
        if (checkedNumbers.length === 1 && !localStorage.getItem("seenHowToPointer")) {
            setShowHowToPointer(true);
            localStorage.setItem("seenHowToPointer", "true"); // ✅ Immediately persist
            setTimeout(() => {
                setShowHowToPointer(false); // ✅ Let it vanish visually
            }, 10000);
        }
    }, [checkedNumbers]);


    useEffect(() => {
        if (prizeWinners.length > 0 && !localStorage.getItem("seenLeaderboardPointer")) {
            setShowLeaderboardPointer(true);
            localStorage.setItem("seenLeaderboardPointer", "true"); 
            setTimeout(() => {
                setShowLeaderboardPointer(false);
            }, 10000);
        }
    }, [prizeWinner?.prizeId]); 


    function closeGame() {
        audioEngine.playSFX("tap")
        const timepassSDK = TimepassSDK.getInstance();
        timepassSDK.exitClicked();
    }

    function openHowToModal() {
        audioEngine.playSFX("tap")
        localStorage.setItem("seenHowToPointer", "true");
        setShowHowToPointer(false);
        setIsModalOpen(true);
    }

    function openLeaderboardModal() {
        audioEngine.playSFX("tap")
        localStorage.setItem("seenLeaderboardPointer", "true");
        setShowLeaderboardPointer(false);
        setIsLeaderboardModalOpen(true);
    }

    return (
        <IconContainer>
            <Icon
                src={isMuted ? "unmute.png" : "mute.png"}
                alt="Mute"
                onClick={toggleMute}
            />

            {/* How to play */}
            <div style={{position: "relative"}}>
                <Icon
                    src="qna.png"
                    alt="Q&A"
                    onClick={openHowToModal}
                />
                {showHowToPointer && (
                    <Pointer>
                        <img
                            draggable={false}
                            src="./hand-black.png"
                        />
                    </Pointer>
                )}
            </div>

            {/* Leaderboard */}
            <div style={{position: "relative"}}>
                <Icon
                    src="leaderboard.png"
                    alt="Leaderboard"
                    onClick={openLeaderboardModal}
                />
                {showLeaderboardPointer && (
                    <Pointer>
                        <img
                            draggable={false}
                            src="./hand-black.png"
                        />
                    </Pointer>
                )}
            </div>

            <Icon src="cross-3.png" alt="exit" onClick={closeGame}/>

            {isModalOpen && (
                <HowToPlayModal
                    windowHeight={windowHeight}
                    onClose={() => {
                        setIsModalOpen(false)
                        audioEngine.playSFX("tap")
                    }}
                />
            )}

            {isLeaderboardModalOpen && (
                <LeaderboardModal onClose={() => {
                    audioEngine.playSFX("tap")
                    setIsLeaderboardModalOpen(false)
                }}/>
            )}
        </IconContainer>
    );
}
